var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "deposit detail" },
    [_vm.lang == _vm.$config.LANG_KOR ? [_vm._m(0)] : [_vm._m(1)]],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll" }, [
      _c("article", { staticClass: "content-header bg-type" }, [
        _c("div", { staticClass: "title" }, [
          _c("h2", [_vm._v("당좌예금(개인용)")])
        ]),
        _c("div", { staticClass: "description" }, [
          _c("p", [
            _vm._v(
              " 현금카드(Eftpos 및 ATM)와 인터넷/모바일뱅킹 사용이 가능한 입출금이 자유로운 계좌(대월한도 당좌대출 설정가능 계좌) "
            )
          ])
        ])
      ]),
      _c("article", { staticClass: "contents" }, [
        _c("dl", { staticClass: "dlist dlist-item--type5" }, [
          _c("dt", [_vm._v("상품유형")]),
          _c("dd", [_vm._v("당좌예금")]),
          _c("dt", [_vm._v("상품개요")]),
          _c("dd", [
            _vm._v(
              "현금카드(Eftpos 및 ATM)와 인터넷/모바일뱅킹 사용이 가능한 입출금이 자유로운 계좌(대월한도 당좌대출 설정가능 계좌)"
            )
          ]),
          _c("dt", [_vm._v("가입대상")]),
          _c("dd", [_vm._v("실명의 개인")]),
          _c("dt", [_vm._v("계약기간")]),
          _c("dd", [_vm._v("제한없음")]),
          _c("dt", [_vm._v("가입통화")]),
          _c("dd", [_vm._v("NZD, USD, AUD, JPY, EUR")]),
          _c("dt", [_vm._v("가입금액")]),
          _c("dd", [
            _vm._v(" 신규가입 시 최저 NZD 20.00"),
            _c("br"),
            _vm._v(" (NZD 이외 기타통화는 0.00) ")
          ]),
          _c("dt", [_vm._v("금리 및 이율")]),
          _c("dd", [_vm._v("통화 : NZD")])
        ]),
        _c("div", { staticClass: "tbl-top-etc" }, [
          _vm._v("(연이율, 세전, 단위 : %)")
        ]),
        _c("table", { staticClass: "table -type03" }, [
          _c("thead", [
            _c("tr", [
              _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $10,000")]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $20,000")]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $100,000")]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $250,000")]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $1,000,000")])
            ])
          ]),
          _c("tbody", [
            _c("tr", [
              _c("td", [_vm._v("0.00")]),
              _c("td", [_vm._v("0.00")]),
              _c("td", [_vm._v("0.00")]),
              _c("td", [_vm._v("0.00")]),
              _c("td", [_vm._v("0.00")])
            ])
          ])
        ]),
        _c("div", { staticClass: "info info-type3" }, [
          _c("p", [_vm._v("· 기타통화(USD, AUD, JPY, EUR) : 예금이율 0.00%")]),
          _c("p", [
            _vm._v(
              "· 모든 예금이율은 시장금리상황에 따라 변동이 있을수 있습니다."
            )
          ])
        ]),
        _c("br"),
        _c("div", { staticClass: "info info-type4" }, [
          _c("strong", [_vm._v("수수료")]),
          _c("p", { staticClass: "side-arrow" }, [_vm._v("후취수수료")]),
          _c("p", [_vm._v("1) 계좌관리수수료")]),
          _c("p", [_vm._v("2) 거래수수료")]),
          _c("p", [_vm._v("- 입출금 창구이용료 NZ$0.50/건")]),
          _c("p", [
            _vm._v("- ATM 이용 월 기준 1-5회 NZ$0.40/건(5회이상 NZ$0.75/건)")
          ]),
          _c("p", [_vm._v("- EFTPOS NZ$0.25/건")]),
          _c("p", [_vm._v("- 수표사용수수료 : NZ$0.50/장")])
        ]),
        _c("div", { staticClass: "info info-type4" }, [
          _c("p", { staticClass: "side-arrow" }, [_vm._v("현찰수수료")]),
          _c("p", [_vm._v("1) NZD")]),
          _c("table", { staticClass: "table -type02" }, [
            _c("colgroup", [_c("col", { attrs: { width: "23%" } }), _c("col")]),
            _c("tbody", [
              _c("tr", [
                _c("th", { attrs: { scope: "row" } }, [_vm._v("지폐")]),
                _c("td", [
                  _c("div", { staticClass: "info info-type4" }, [
                    _c("p", { staticClass: "side-arrow" }, [
                      _vm._v("현금거래 및 현금입금")
                    ]),
                    _c("p", [_vm._v("$3,000이상 초과액부터")]),
                    _c("p", [_vm._v("$1,000당 $2.50")]),
                    _c("em")
                  ]),
                  _c("div", { staticClass: "info info-type4" }, [
                    _c("p", { staticClass: "side-arrow" }, [
                      _vm._v("현금출금")
                    ]),
                    _c("p", [_vm._v("$10,000이상 초과액부터")]),
                    _c("p", [_vm._v("$1,000당 $2.50")])
                  ])
                ])
              ]),
              _c("tr", [
                _c("th", { attrs: { scope: "row", rowspan: "2" } }, [
                  _vm._v("동전")
                ]),
                _c("td", [
                  _c("div", { staticClass: "info info-type4" }, [
                    _c("p", [_vm._v("$2.50 per $100 of gold coins")])
                  ])
                ])
              ]),
              _c("tr", [
                _c("td", [
                  _c("div", { staticClass: "info info-type4" }, [
                    _c("p", [_vm._v("$2.50 per $10 of all other cents")])
                  ])
                ])
              ])
            ])
          ]),
          _c("p", [_vm._v("2) NZD 외 영업점취급 외국통화(USD, AUD, JPY)")]),
          _c("p", [
            _vm._v("- 외화계좌에 외화현찰 입금 시 입금금액 2% (Min $5)")
          ]),
          _c("p", [
            _vm._v("- 외화계좌에서 외화현찰 입금 시 출금액 1% (Min $5)")
          ])
        ]),
        _c("div", { staticClass: "info info-type4" }, [
          _c("strong", [_vm._v("가입방법")]),
          _c("p", [_vm._v("영업점가입")])
        ]),
        _c("div", { staticClass: "info info-type4" }, [
          _c("strong", [_vm._v("가입시 필요서류")]),
          _c("p", [
            _vm._v("신분증 (여권 또는 NZ운전면허증), 주소지 증명서 등")
          ]),
          _c("p", [
            _vm._v("※ 기타 자세한 필요서류는 영업점으로 문의하시기 바랍니다.")
          ])
        ]),
        _c("div", { staticClass: "info info-type4" }, [
          _c("strong", [_vm._v("유의사항 및 기타")]),
          _c("p", [
            _vm._v("- 정기예금 및 대출 NZ$50,000 이상 시 후취수수료 면제")
          ]),
          _c("p", [_vm._v("- ATM 이용 현금인출금액 하루 최대 NZ$2,000")]),
          _c("p", [_vm._v("- EFTPOS 이용 거래가능금액 하루 최대 NZ$5,000")]),
          _c("p", [_vm._v("- 무승인 당좌대월 수수료 적용")]),
          _c("p", [
            _vm._v(" - 거래 유형 및 상품 종류 등에 따라 별도의 수수료 발생 "),
            _c("br"),
            _vm._v(" 상기 수수료는 수시 변경될 수 있습니다. ")
          ]),
          _c("p", [
            _vm._v("- 기타 자세한 내용은 영업점으로 문의하시기 바랍니다.")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll" }, [
      _c("article", { staticClass: "content-header bg-type" }, [
        _c("div", { staticClass: "title" }, [
          _c("h2", [_vm._v("PERSONAL CHEQUE ACCOUNT")])
        ]),
        _c("div", { staticClass: "description" }, [
          _c("p", [
            _vm._v(
              " A transactional account (can be set as the overdraft account) that can deposit/withdraw funds flexibly with access via Cash Card (Eftpos and ATM) and Internet/Mobile Banking. "
            )
          ])
        ])
      ]),
      _c("article", { staticClass: "contents" }, [
        _c("dl", { staticClass: "dlist dlist-item--type5" }, [
          _c("dt", [_vm._v("Types")]),
          _c("dd", [_vm._v("Cheque Account")]),
          _c("dt", [_vm._v("About the products")]),
          _c("dd", [
            _vm._v(
              " A transactional account (can be set as the overdraft account) that can deposit/withdraw funds flexibly with access via Cash Card (Eftpos and ATM) and Internet/Mobile Banking. "
            )
          ]),
          _c("dt", [_vm._v("Eligibilty")]),
          _c("dd", [_vm._v("Personal customers")]),
          _c("dt", [_vm._v("Contract Terms")]),
          _c("dd", [_vm._v("No restrictions")]),
          _c("dt", [_vm._v("Available currency")]),
          _c("dd", [_vm._v("NZD, USD, AUD, JPY, EUR")]),
          _c("dt", [_vm._v("Deposit amount")]),
          _c("dd", [
            _vm._v(
              "Minimum NZD 20.00 deposit required (For other currencies: No restrictions)"
            )
          ]),
          _c("dt", [_vm._v("Rates")]),
          _c("dd", [_vm._v("Currency : NZD")])
        ]),
        _c("div", { staticClass: "tbl-top-etc" }, [
          _vm._v("(Per Annum, pertax, unit : %)")
        ]),
        _c("table", { staticClass: "table -type03" }, [
          _c("thead", [
            _c("tr", [
              _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $10,000")]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $20,000")]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $100,000")]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $250,000")]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $1,000,000")])
            ])
          ]),
          _c("tbody", [
            _c("tr", [
              _c("td", [_vm._v("0.00")]),
              _c("td", [_vm._v("0.00")]),
              _c("td", [_vm._v("0.00")]),
              _c("td", [_vm._v("0.00")]),
              _c("td", [_vm._v("0.00")])
            ])
          ])
        ]),
        _c("div", { staticClass: "info info-type3" }, [
          _c("p", [
            _vm._v(
              "· Other currencies(USD, AUD, JPY, EUR) : interest rate 0.00%"
            )
          ]),
          _c("p", [
            _vm._v(
              "· All savings interest rates are subject to change according to market interest rate trends."
            )
          ])
        ]),
        _c("br"),
        _c("div", { staticClass: "info info-type4" }, [
          _c("strong", [_vm._v("Fees")]),
          _c("p", { staticClass: "side-arrow" }, [_vm._v("Monthly fees")]),
          _c("p", [_vm._v("1) Account maintenance fee")]),
          _c("p", [_vm._v("2) Transaction service fees")]),
          _c("p", [
            _vm._v(
              "- Deposit/withdrawal(Teller counter) NZ$0.50/per transaction"
            )
          ]),
          _c("p", [_vm._v("- ATM : NZ$0.40 up to 5 times, NZ$0.75 for over")]),
          _c("p", [_vm._v("- EFTPOS : NZ$0.25/per transaction")]),
          _c("p", [_vm._v("- Cheque : NZ$0.50/per cheque")])
        ]),
        _c("div", { staticClass: "info info-type4" }, [
          _c("p", { staticClass: "side-arrow" }, [_vm._v("Cash handing fees")]),
          _c("p", [_vm._v("1) NZD")]),
          _c("table", { staticClass: "table -type02" }, [
            _c("colgroup", [_c("col", { attrs: { width: "23%" } }), _c("col")]),
            _c("tbody", [
              _c("tr", [
                _c("th", { attrs: { scope: "row" } }, [_vm._v("Notes")]),
                _c("td", [
                  _c("div", { staticClass: "info info-type4" }, [
                    _c("p", { staticClass: "side-arrow" }, [
                      _vm._v("Cash transactions/Cash deposits")
                    ]),
                    _c("p", [_vm._v("Up to $3,000 Free")]),
                    _c("p", [_vm._v("$2.50 over exceeding $1,000")]),
                    _c("em")
                  ]),
                  _c("div", { staticClass: "info info-type4" }, [
                    _c("p", { staticClass: "side-arrow" }, [
                      _vm._v("Cash withdrawals")
                    ]),
                    _c("p", [_vm._v("Up to $10,000 Free")]),
                    _c("p", [_vm._v("$2.50 over exceeding $1,000")])
                  ])
                ])
              ]),
              _c("tr", [
                _c("th", { attrs: { scope: "row", rowspan: "2" } }, [
                  _vm._v("Coins")
                ]),
                _c("td", [
                  _c("div", { staticClass: "info info-type4" }, [
                    _c("p", [_vm._v("$2.50 per $100 of gold coins")])
                  ])
                ])
              ]),
              _c("tr", [
                _c("td", [
                  _c("div", { staticClass: "info info-type4" }, [
                    _c("p", [_vm._v("$2.50 per $10 of all other cents")])
                  ])
                ])
              ])
            ])
          ]),
          _c("p", [_vm._v("2) USD, AUD, JPY (Notes only)")]),
          _c("p", [
            _vm._v(
              "- Foreign cash deposit to Foreign Currency Account : 2% of foreign amount (Minimum $5)"
            )
          ]),
          _c("p", [
            _vm._v(
              "- Foreign cash Withdrawal from Foreign Currency Account : 1% of foreign amount (Minimum $5)"
            )
          ])
        ]),
        _c("div", { staticClass: "info info-type4" }, [
          _c("strong", [_vm._v("How to apply")]),
          _c("p", [_vm._v("Apply at the branch")])
        ]),
        _c("div", { staticClass: "info info-type4" }, [
          _c("strong", [_vm._v("Required documents for application")]),
          _c("p", [
            _vm._v("Passport or NZ driver's licence & proof of address")
          ]),
          _c("p", [
            _vm._v(
              "※ Please contact our branch for more detailed information on required documents."
            )
          ])
        ]),
        _c("div", { staticClass: "info info-type4" }, [
          _c("strong", [_vm._v("Notices and others")]),
          _c("p", [
            _vm._v(
              "- With over NZ$50,000 of Term Deposit or Loan, No Monthly Fee"
            )
          ]),
          _c("p", [_vm._v("- Daily ATM withdrawal limit of NZ$2,000")]),
          _c("p", [_vm._v("- Daily EFTPOS transaction limit of NZ$5,000")]),
          _c("p", [_vm._v("- Unarranged overdraft free may apply")]),
          _c("p", [
            _vm._v(
              "- Additional service fees may apply. Fees are subject to change from time to time."
            )
          ]),
          _c("p", [_vm._v("- For further details, please contact the branch.")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }